import threeCConfig from './ThreeCConfig'
import JWTService from '@/shared/services/jwt'

/**
 * Serviço para gerenciar a integração 3C Plus
 */
class ThreeCPlusService {
  constructor () {
    this.isInitialized = false
    this.currentUserId = null
  }

  /**
   * Inicializa o serviço 3C Plus
   */
  async init () {
    try {
      let userId = null
      try {
        userId = JWTService.GetUserId()
      } catch (error) {
        console.error('❌ Erro ao obter userId:', error)
        return false
      }

      if (!userId) {
        return false
      }

      this.currentUserId = userId

      try {
        const configLoaded = await threeCConfig.init(this.currentUserId)

        // Se a configuração não foi carregada (404 ou erro), não inicializa
        if (!configLoaded || !threeCConfig.isLoaded || !threeCConfig.config) {
          console.warn('⚠️ ThreeCPlus: Configuração não disponível no backend')
          this.isInitialized = false
          return false
        }

        this.isInitialized = true
      } catch (error) {
        console.error('❌ Erro ao inicializar ThreeCPlus:', error)
        this.isInitialized = false
        return false
      }

      const canUse = this.canUse
      return canUse
    } catch (error) {
      this.isInitialized = false
      return false
    }
  }

  /**
   * Verifica se a integração 3C Plus está habilitada globalmente
   */
  get isEnabled () {
    try {
      if (!threeCConfig || !threeCConfig.isLoaded) {
        return false
      }

      return threeCConfig.isEnabled
    } catch (error) {
      return false
    }
  }

  /**
   * Verifica se o usuário atual tem 3C Plus habilitado
   */
  get isUserEnabled () {
    try {
      if (!threeCConfig || !threeCConfig.isLoaded) {
        return false
      }

      return threeCConfig.isUserEnabled
    } catch (error) {
      return false
    }
  }

  /**
   * Verifica se o usuário pode usar 3C Plus (verifica configuração global E do usuário)
   */
  get canUse () {
    try {
      if (!this.isInitialized) {
        return false
      }

      const isEnabled = this.isEnabled

      if (!isEnabled) {
        return false
      }

      const isUserEnabled = this.isUserEnabled

      const result = isEnabled && isUserEnabled
      return result
    } catch (error) {
      return false
    }
  }

  /**
   * Retorna as configurações atuais
   */
  get config () {
    try {
      if (!threeCConfig) {
        return {
          domain: '',
          apiBaseUrl: '',
          socketUrl: '',
          connectionTimeout: 15000,
          iframeTimeout: 10000,
          socketOptions: {}
        }
      }

      return {
        domain: threeCConfig.DOMAIN,
        apiBaseUrl: threeCConfig.API_BASE_URL,
        socketUrl: threeCConfig.SOCKET_URL,
        connectionTimeout: threeCConfig.CONNECTION_TIMEOUT,
        iframeTimeout: threeCConfig.IFRAME_LOAD_TIMEOUT,
        socketOptions: threeCConfig.SOCKET_OPTIONS
      }
    } catch (error) {
      return {
        domain: '',
        apiBaseUrl: '',
        socketUrl: '',
        connectionTimeout: 15000,
        iframeTimeout: 10000,
        socketOptions: {}
      }
    }
  }

  /**
   * Retorna as credenciais do usuário atual
   */
  get credentials () {
    try {
      if (!threeCConfig) {
        return {
          user: '',
          password: ''
        }
      }

      return {
        user: threeCConfig.USER,
        password: threeCConfig.PASSWORD
      }
    } catch (error) {
      return {
        user: '',
        password: ''
      }
    }
  }

  /**
   * Recarrega as configurações
   */
  async reload () {
    try {
      if (this.currentUserId) {
        await threeCConfig.reload(this.currentUserId)
      }
    } catch (error) {
      console.warn('Erro ao recarregar configurações 3C Plus:', error)
    }
  }

  /**
   * Verifica se deve mostrar o ícone do VoIP no header
   */
  shouldShowVoipIcon () {
    try {
      if (!this.isInitialized) {
        return false
      }

      return this.canUse
    } catch (error) {
      return false
    }
  }

  /**
   * Verifica se deve fazer requisições para a API 3C Plus
   */
  shouldMakeRequests () {
    try {
      if (!this.isInitialized) {
        return false
      }
      return this.canUse
    } catch (error) {
      console.warn('Erro ao verificar se deve fazer requisições 3C Plus:', error)
      return false
    }
  }

  /**
   * Obtém informações de debug
   */
  getDebugInfo () {
    try {
      return {
        isInitialized: this.isInitialized,
        currentUserId: this.currentUserId,
        isEnabled: this.isEnabled,
        isUserEnabled: this.isUserEnabled,
        canUse: this.canUse,
        config: this.config,
        hasCredentials: !!(this.credentials.user && this.credentials.password)
      }
    } catch (error) {
      return {
        isInitialized: false,
        currentUserId: null,
        isEnabled: false,
        isUserEnabled: false,
        canUse: false,
        config: null,
        hasCredentials: false
      }
    }
  }
}

const threeCPlusService = new ThreeCPlusService()

export default threeCPlusService



// WEBPACK FOOTER //
// ./src/shared/services/voip/ThreeCPlusService.js